import { Box, ButtonGroup, Container, Flex, Heading, TabPanel, TabPanels, Text } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import BoxDivider from 'components/ui/BoxDivider';
import ButtonBack from 'components/ui/ButtonBack';
import FixedBar from 'components/ui/FixedBar';
import SaveButton from 'components/ui/SaveButton';
import SubmitButton from 'components/ui/SubmitButton';
import Lists from 'features/lists/components/Lists';
import { useMessages } from 'hooks/useMessages';
import { ArrayRequiredTestFunction } from 'lib/validation';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import ListsCompanyView from '../components/ListsCompanyView';
import ListsTagView from '../components/ListsTagView';
import { useSetListsToContent } from '../hooks/useSetListsToContent';

export interface FormValues {
  lists: [];
  onlySave?: boolean;
}

const validationSchema = Yup.object().shape({
  lists: Yup.mixed().test('lists', '', ArrayRequiredTestFunction),
});

export default function FormLists({ content }: any) {
  const { id } = useParams();
  const navigate = useNavigate();

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as unknown as Resolver<FormValues>,
    defaultValues: {
      lists: content?.lists ? content.lists.map(({ id } ) => id) : [],
    }
  });

  const { handleSubmit, formState: { isValid } } = methods;

  const { onSuccess } = useMessages({ success: 'Fique tranquilo, seu trabalho foi salvo' });

  const { onSetListsToContent, isPending, variables } = useSetListsToContent({
    contentId: id,
    onSuccess: (onlySave) => {
      if (onlySave)
        onSuccess();
      else
        navigate(`/disparos-de-report/editar/${id}/conferir-dados`)
    }
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => onSetListsToContent(data);

  const onSave: SubmitHandler<FormValues> = (data) => onSubmit({...data, onlySave: true});

  return (
    <FormProvider {...methods}>
      <Box 
        as="form" 
        onSubmit={handleSubmit(onSubmit)}
        w="full"
        pos="relative"
      >
        <BoxDivider 
          top="160px"
        />
        
        <Container 
          variant="internal"
          flexDirection="column"
          
        >
          <Flex 
            flex={1}
            justifyContent="space-between"
            mb="40px"
          >
            <Heading as="h1" size="h1">
              Listas
              <Text as="span">Selecione um padrão de conteúdo abaixo ou crie um novo</Text>
            </Heading>
          </Flex>

          <Lists
            searchParams={{
              contentGroupId: content?.contentGroupId
            }}
          >
            <TabPanels mt="60px" pb="90px">
              <TabPanel>
                <ListsCompanyView />
              </TabPanel>
              <TabPanel>
                <ListsTagView />
              </TabPanel>
            </TabPanels>
          </Lists>

          <FixedBar>
            <ButtonBack 
              as={Link}
              to={`/disparos-de-report/editar/${id}/conteudo`}
            />

            <ButtonGroup>
              <SaveButton 
                isDisabled={!isValid}
                isLoading={variables?.onlySave && isPending}
                onClick={handleSubmit(onSave)}
              >
                Salvar
              </SaveButton>

              <SubmitButton
                isDisabled={!isValid}
                isLoading={!variables?.onlySave && isPending}
              >
                Salvar e continuar
              </SubmitButton>

            </ButtonGroup>
            
          </FixedBar>
        </Container>
      </Box>
    </FormProvider>
  )
}
